import Lottie from "lottie-react";
import animationData from "./warning.json";

interface LottieAnimationProps {
  height?: number;
  width?: number;
  loop?: boolean;
}

export function WarningLottieAnimation({
  height,
  width,
  loop,
}: LottieAnimationProps) {
  return (
    <div style={{ height, width }}>
      <Lottie animationData={animationData} loop={loop} />
    </div>
  );
}
